import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_yp_db/layout";
import { DashboardPage } from "./pages/DashboardPage";

const UsersPage = lazy(() =>
  import("./modules/UserManagement/UserManagement")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);
const Settings = lazy(() =>
  import("./modules/Settings/Settings")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (<>
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <Route path="/user-management" component={UsersPage} />
        <Route path="/profile" component={UserProfilepage} />
        <Route path="/settings" component={Settings} />
        <Route path="/event-management" component={Settings} />
        <Route path="/professional-management" component={Settings} />
        <Route path="/legal-question-management" component={Settings} />
        <Route path="/natural-justice-material-management" component={Settings} />
        <Route path="/period-bank-management" component={Settings} />
        <Route path="/tree-nursery-bank-management" component={Settings} />
        <Route path="/question-answer-management" component={Settings} />
        <Route path="/rapid-response-management" component={Settings} />
        <Route path="/reported-case-management" component={Settings} />
        <Route path="/social-economic-right-management" component={Settings} />
        <Route path="/justice-centre-management" component={Settings} />
        <Redirect to="/error/err" />
      </Switch>
    </Suspense>
  </>);
}
